<h2 mat-dialog-title>Confirm Action</h2>
<mat-dialog-content>
  <p>{{ data.message }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-button color="warn" (click)="onConfirm()">Delete</button>
</mat-dialog-actions>